import React, { useState } from 'react';
import { MessageTemplate } from '../../api/types/messages';
import { Icon, keyBadge } from '../ui';
import { TranslationListView } from './MessageTranslationView';
import { ListGroup, Badge, Button } from "react-bootstrap";
import { LanguageCodeVariant, MessageTypeVariant } from '../../constants';

interface TemplateProps {
    template: MessageTemplate
    preview: boolean;
    showId?: boolean;
    toggle?: boolean;
 }
 
 export const MessageTemplateComponent: React.FC<TemplateProps> = (props) => {
 
    const template = props.template;
 
    const [shown, setShow] = useState(false);
 
    const showText = ()=> {
       const text = shown ? 'Hide' : 'Show';
       const icon = shown ? 'arrow-up' : 'arrow-down';
       return <span><Icon name={icon} className="me-1" />{text}</span> 
    }

    const showId = props.showId ?? true;
 
    return <ListGroup.Item>
       <div className='m-1'>
       <Badge bg={MessageTypeVariant} className="me-1">{template.messageType}</Badge>
       { showId && template.id ? <span className="entity-id me-1">{ keyBadge(template.id) }</span> : ''}
       <span>{ template.translations.length } translations, default <Badge bg={LanguageCodeVariant} className='ms-1'>{template.defaultLanguage}</Badge></span>
       <Button size="sm" className='ms-1' onClick={()=>{ setShow(!shown) }}>{ showText() }</Button>
       </div>
       { shown ? <TranslationListView translations={template.translations} preview={props.preview}/> : ''}
    </ListGroup.Item>
 
 }
 